// @flow

import _ from 'lodash';

import { runtimeId as runtimeIdValue } from 'runtime-id';

import { Error } from 'error';
import { ValidationError } from 'rgs-knockout-validation';

export type StartDataGetter = () => Object;
export type ResolveDataGetter = (v: any) => Object;
export type RejectDataGetter = (e: Error) => Object;

export const noopDataGetter = () => ({});

export const runtimeId = _.constant({ runtimeId: runtimeIdValue });

export const validationEventFromValidationError = (e: Error) => {
	if (!(e instanceof ValidationError)) {
		return {};
	}

	const validationEvents = _.map(
		e.validationStates,
		({ message, value, name, form }) => ({
			message,
			field: { value, name },
			form: { name: form && form.name },
		}));

	return {
		validationEvent: _.head(validationEvents),
		validationEvents,
	};
};

export const errorInfoFromError = (e: Error) => {
	return {
		Error: {
			ErrorCode: e.code || 'RGSRUUI-99099',
			Description: {
				name: e.name,
				message: e.message,
				stack: e.stack,
			},
		},
	};
};

export const responseJSONStatusFromError = (e: Error) => {
	if (!e.response || !e.response.responseJSON || !e.response.responseJSON.Status) {
		return {};
	}

	return {
		Status: e.response.responseJSON.Status,
	};
};

export const messageForClientFromHandledError = (e: Error) => {
	if (!e.handled) {
		return {};
	}

	if (e.handled.type !== 'notification') {
		return {};
	}

	return {
		Error: {
			MessageForClient: e.handled.message,
		},
	};
};

export const defaultRejectDataGetters = [
	validationEventFromValidationError,
	errorInfoFromError,
	runtimeId,

	responseJSONStatusFromError,
	messageForClientFromHandledError,
];

export const defaultStartDataGetters = [
	runtimeId,
];

/* TODO: flow, wtf?
type DataGetter = StartDataGetter | ResolveDataGetter | RejectDataGetter;
function joinDataGetters<DG: DataGetter> (dgs: DG | Array<DG>): DG {
	if (!_.isArray(dgs)) {
		return ((dgs: any): DG);
	}
	return (...args) => _.extend(..._.map(dgs, x => x(...args)));
}
*/
type DataGetter = StartDataGetter | ResolveDataGetter | RejectDataGetter;
export function joinDataGetters <DG: DataGetter> (dgs: Array<DG> | DG): DG {
	if (!_.isArray(dgs)) {
		return ((dgs: any): DG);
	}

	const f = (...args: *) => {
		const results = _.map(((dgs: any): Array<DG>), x => x(...args));
		return _.defaultsDeep(...results);
	};

	return ((f: any): DG);
}
